import { render } from "./EventSortFilterComp.vue?vue&type=template&id=64cadeaa&scoped=true&ts=true"
import script from "./EventSortFilterComp.vue?vue&type=script&lang=ts"
export * from "./EventSortFilterComp.vue?vue&type=script&lang=ts"

import "./EventSortFilterComp.vue?vue&type=style&index=0&id=64cadeaa&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64cadeaa"]])

export default __exports__